<div class="sec-head">
  <h2>{{ 'Unit preferences' | translate }}</h2>
  <p>{{ 'Units used in readings, charts and reports.' | translate }}</p>
</div>

<div class="units">
  @for (unit of units; track trackByIndex($index)) {
    <div class="unit-row">
      <span class="label">{{ unit.label | translate }}</span>
      <app-account-segmented-control
        [compact]="true"
        [options]="unit.options"
        [value]="profile[unit.property]"
        [label]="unit.label | translate"
        (valueChange)="onUnitChange(unit.property, $event)"
      ></app-account-segmented-control>
    </div>
  }
</div>
